import { AES, enc } from "crypto-js";

class CryptoHelper{
	secretKey = import.meta.env.VITE_SECRET_KEY
	
	encrypt = (dataStr)=>{	
		const encrypted= AES.encrypt(dataStr, this.secretKey)
		const chiperText = encrypted.toString()
		
		return chiperText
	}
	
	decrypt = (chiperText)=>{
		const bytes = AES.decrypt(chiperText, this.secretKey)
		const decrypted = JSON.parse(bytes.toString(enc.Utf8))

		return decrypted
	}
}

export {CryptoHelper as default}